/* ============================================================
   EI Page d'autorité — Tracking GA4/GTM
   8 events instrumentés :
   1. ei_autorite_view              (chargement de la page)
   2. ei_autorite_ia_referrer       (arrivée depuis ChatGPT/Perplexity/Claude/Gemini/etc.)
   3. ei_autorite_scroll_{25,50,75,100}
   4. ei_autorite_faq_open
   5. ei_autorite_cta_click
   6. ei_autorite_article_click
   7. ei_autorite_b2b_contact
   8. ei_autorite_trustpilot_click

   Tous les events utilisent les dimensions custom EI standardisées :
   ei_source, ei_action, ei_product, ei_version (+ event-specific properties).

   Push direct dans window.dataLayer (consommable par GTM → GA4).
   Respecte le consentement cookie : si GTM n'est pas chargé (refus cookies),
   les events restent dans dataLayer mais ne partent pas en GA4 — comportement attendu.
   ============================================================ */
(function() {
  if (window.__eiAutoriteTrackingInit) return;
  window.__eiAutoriteTrackingInit = true;

  /* Lire les data-attributes du conteneur tracking */
  var root = document.querySelector('[data-ei-autorite-tracking]');
  if (!root) return;

  var TOPIC = root.getAttribute('data-ei-autorite-topic') || 'unknown';
  var VERSION = root.getAttribute('data-ei-autorite-version') || 'v1.0';

  /* Helper : push dataLayer avec dimensions EI standard */
  function push(action, extra) {
    var data = {
      event: 'ei_autorite_' + action,
      ei_source: 'page_autorite',
      ei_action: action,
      ei_product: TOPIC,
      ei_version: VERSION
    };
    if (extra) {
      for (var k in extra) { if (Object.prototype.hasOwnProperty.call(extra, k)) data[k] = extra[k]; }
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(data);
  }

  /* ---------- 1. page_view + IA referrer detection ---------- */
  var referrer = (document.referrer || '').toLowerCase();
  var iaSources = {
    'chatgpt.com': 'chatgpt',
    'chat.openai.com': 'chatgpt',
    'perplexity.ai': 'perplexity',
    'claude.ai': 'claude',
    'gemini.google.com': 'gemini',
    'bard.google.com': 'gemini',
    'copilot.microsoft.com': 'copilot',
    'bing.com/chat': 'bing-copilot',
    'you.com': 'you',
    'meta.ai': 'meta-ai',
    'mistral.ai': 'mistral',
    'duckduckgo.com/ai': 'duckduckgo-ai'
  };

  var iaSource = 'none';
  for (var domain in iaSources) {
    if (referrer.indexOf(domain) !== -1) {
      iaSource = iaSources[domain];
      break;
    }
  }

  push('view', { ei_referrer: referrer || 'direct', ei_ia_source: iaSource });
  if (iaSource !== 'none') {
    push('ia_referrer', { ei_ia_source: iaSource, ei_referrer: referrer });
  }

  /* ---------- 2. scroll_depth tracking ---------- */
  var scrollThresholds = [25, 50, 75, 100];
  var scrollHit = {};
  var scrollTimer = null;

  function checkScroll() {
    var docHeight = Math.max(
      document.documentElement.scrollHeight,
      document.body.scrollHeight
    ) - window.innerHeight;
    if (docHeight <= 0) return;
    var scrolled = window.pageYOffset || document.documentElement.scrollTop;
    var pct = Math.round((scrolled / docHeight) * 100);

    for (var i = 0; i < scrollThresholds.length; i++) {
      var t = scrollThresholds[i];
      if (pct >= t && !scrollHit[t]) {
        scrollHit[t] = true;
        push('scroll_' + t, { ei_scroll_pct: t });
      }
    }
  }

  function onScroll() {
    if (scrollTimer) return;
    scrollTimer = setTimeout(function() {
      scrollTimer = null;
      checkScroll();
    }, 150);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  checkScroll(); /* immediate check au cas où on arrive déjà scrolled */

  /* ---------- 3. FAQ open tracking ---------- */
  var faqItems = document.querySelectorAll('.ei-autorite__faq-item');
  for (var i = 0; i < faqItems.length; i++) {
    (function(item, index) {
      item.addEventListener('toggle', function() {
        if (item.open) {
          var qEl = item.querySelector('.ei-autorite__faq-q');
          var question = qEl ? qEl.textContent.trim() : '';
          push('faq_open', { ei_question_index: index + 1, ei_question_label: question });
        }
      });
    })(faqItems[i], i);
  }

  /* ---------- 4. CTA / B2B / Article / Trustpilot click tracking ---------- */
  document.addEventListener('click', function(e) {
    var target = e.target;
    /* Remonter au lien ou bouton parent */
    var maxDepth = 6;
    while (target && maxDepth-- > 0 && !(target.tagName === 'A' || target.tagName === 'BUTTON')) {
      target = target.parentNode;
    }
    if (!target) return;

    var href = target.getAttribute && target.getAttribute('href') || '';
    var label = (target.textContent || '').trim().slice(0, 80);
    var cls = target.className || '';
    var classStr = typeof cls === 'string' ? cls : '';

    /* B2B contact (mailto) */
    if (classStr.indexOf('ei-autorite__b2b-cta') !== -1 || href.indexOf('mailto:') === 0) {
      push('b2b_contact', { ei_cta_label: label, ei_cta_destination: href });
      return;
    }
    /* Article pilier */
    if (classStr.indexOf('ei-autorite__article') !== -1) {
      var handle = href.split('/').pop() || href;
      push('article_click', { ei_article_handle: handle, ei_cta_destination: href });
      return;
    }
    /* Trustpilot externe */
    if (href.indexOf('trustpilot.com') !== -1) {
      push('trustpilot_click', { ei_cta_destination: href });
      return;
    }
    /* CTA générique (lime button) */
    if (classStr.indexOf('ei-autorite__cta') !== -1 ||
        classStr.indexOf('ei-autorite__sticky-cta') !== -1 ||
        classStr.indexOf('ei-autorite__trust-pill') !== -1 ||
        classStr.indexOf('ei-autorite__tp-link') !== -1 ||
        classStr.indexOf('ei-autorite__selection-item') !== -1) {
      push('cta_click', { ei_cta_label: label, ei_cta_destination: href });
      return;
    }
  }, true);

})();
